import React, {useState} from 'react'
import {useSelector} from 'react-redux'
import {useNavigate, useLocation} from 'react-router-dom'

import {FiChevronDown, FiChevronRight, FiFileText, FiPenTool, FiSettings, FiUserCheck} from 'react-icons/fi'
import {
  VmoAccordion,
  VmoAccordionContent,
  VmoAccordionTitle,
  VmoButton,
  VmoIcon,
  VmoMenu,
  VmoMenuItem,
  VmoTooltip,
} from 'vmo-library'
import {get, getPathWithPrefix, isActiveNavlink} from 'utils/helper'
import {CLIENT_PORTAL_PATH} from 'constants/path'

const ClientPortalMenu = () => {
  const {pathname} = useLocation()
  const navigate = useNavigate()

  const [active, setActive] = useState([])

  const {generalSetting = {}} = useSelector(state => state.clientPortal)
  const {enableClientPortal = false} = generalSetting

  const getHref = () => {
    const accountInfo = get(['accountInfo'], JSON.parse(window.localStorage.getItem('support')))
    return `https://${accountInfo.domain}.${process.env.REACT_APP_DOMAIN}/support/client-portal`
  }
  const menus = [
    {
      title: 'Client Portal',
      key: 'client-portal',
      items: [
        {
          path: getPathWithPrefix(CLIENT_PORTAL_PATH.PREFIX, CLIENT_PORTAL_PATH.ANNOUNCEMENTS),
          icon: <FiFileText />,
          label: 'Announcements',
        },
        {
          path: getPathWithPrefix(CLIENT_PORTAL_PATH.PREFIX, CLIENT_PORTAL_PATH.CUSTOMIZATION),
          icon: <FiPenTool />,
          label: 'Customization',
        },
      ],
    },
    {
      title: 'Settings',
      key: 'setting-portal',
      items: [
        {
          path: getPathWithPrefix(CLIENT_PORTAL_PATH.PREFIX, CLIENT_PORTAL_PATH.GENERAL),
          icon: <FiSettings />,
          label: 'General',
        },
        {
          path: getPathWithPrefix(CLIENT_PORTAL_PATH.PREFIX, CLIENT_PORTAL_PATH.TICKETS),
          icon: <FiUserCheck />,
          label: 'Tickets',
        },
      ],
    },
  ]
  const isActive = key => {
    if (active.length === 0) return true
    return active.includes(key)
  }
  const handleMenuExpand = key => {
    const menus = [...active]
    if (menus.includes(key)) {
      menus.splice(menus.indexOf(key), 1)
      setActive(menus)
    } else {
      setActive([...menus, key])
    }
  }

  return (
    <VmoMenu vertical secondary className="set-list">
      {menus.map((section, index) => (
        <VmoAccordion key={index}>
          <VmoAccordionTitle onClick={() => handleMenuExpand(section.key)}>
            {section.title}
            {isActive(section.key) ? <FiChevronDown /> : <FiChevronRight />}
          </VmoAccordionTitle>
          <VmoAccordionContent active={isActive(section.key)}>
            {section.items.map((item, idx) => (
              <VmoMenuItem key={item.path} active={isActiveNavlink(item.path)} onClick={() => navigate(item.path)}>
                {item.icon} {item.label}
              </VmoMenuItem>
            ))}
          </VmoAccordionContent>
        </VmoAccordion>
      ))}
      <div className="prevBottom">
        {enableClientPortal ? (
          <VmoButton fluid className="basic-fill-btn mt-3" href={getHref()} target="_blank">
            <VmoIcon name="external alternate" /> Preview
          </VmoButton>
        ) : (
          <VmoTooltip
            content="Please Enable Client Portal"
            trigger={
              <VmoButton primary fluid className="disabled-button mt-3">
                <VmoIcon name="external alternate" /> Preview
              </VmoButton>
            }
          />
        )}
      </div>
    </VmoMenu>
  )
}

export default ClientPortalMenu
